import { FC, useEffect, useState } from 'react';
import styled from './index.module.scss';
import ReactDOM from 'react-dom';
import AnnualSummary from '@/components/MembersDay/FY2024/AnnualSummary';
interface IProps {
    callback?: any;
}

const JoinUsWin: FC<IProps> = ({ callback }) => {
    const [isClient, setIsClient] = useState(false);
    useEffect(() => {
        setIsClient(true);
    }, []);

    if (!isClient) {
        return null;
    }

    return ReactDOM.createPortal(
        <div className={`glo-editor-modal glo-editor-modal-show ${styled.AnnualSummaryModal}`}>
            <div className="glo-editor-modal-wrap">
                <div className="modal-content">
                    <AnnualSummary isModal callback={callback} />
                </div>
            </div>
        </div>,
        document.body,
    );
};

export default JoinUsWin;
